import { registerAction } from '../../Action'

const LOAD_STORY_ACCESS_GROUP_MEMBERS = 'LOAD_STORY_ACCESS_GROUP_MEMBERS'

const reducer = (state = {}, action) => {
  const decoratedUsers = action.payload.data.map((userEntity) => {
    const user = userEntity.user
    return {
      ...user,
      isRequired: userEntity.is_required,
    }
  })

  return {
    ...state,
    access_group_members: {
      ...(state.access_group_members || {}),
      story: {
        ...((state.access_group_members || {}).story || {}),
        [action.payload.story_id]: decoratedUsers,
      },
    },
  }
}

const loadStoryAccessGroupMembers = registerAction(
  LOAD_STORY_ACCESS_GROUP_MEMBERS,
  { reducer }
)

export default loadStoryAccessGroupMembers
